angular.module("acl.visualizer.chartColorPicker", [
  "acl.common.config",
  "acl.common.event",
  "acl.visualizer.charts",
  "acl.visualizer.dataModel",
  "acl.visualizer.tabState",
]);
